import React from "react"
import { graphql } from "gatsby"
import MDXWrapper from "~templates/mdx"

import FluidImage from "~components/fluid-image/fluid-image"
import AsideTopicSeries from "~components/aside-topic-series/aside-topic-series"

import * as styles from "./tutorial.module.css"

const Template = ({ path, externalUrl, summary: description, hideSummary, children, imageTitle, topics }) =>
  !externalUrl && (
    <>
      {imageTitle && (
        <figure className={styles.heroImage}>
          <FluidImage
            relativePath={`${path.replace(/^(.*?)\/?$/, "$1")}/${imageTitle}`}
            alt="Illustration of concept"
            precomposed={true}
          />
        </figure>
      )}

      {children}

      {Boolean(topics) && <AsideTopicSeries topics={topics} />}
    </>
  )

export const query = graphql`
  query ($mdxPath: String) {
    mdx(fileAbsolutePath: { eq: $mdxPath }) {
      body
      tableOfContents(maxDepth: 10)
    }
  }
`

const Wrapper = (props) =>
  MDXWrapper({
    ...props,
    Template,
    pageContext: { withComments: true, withTOC: true, ...props.pageContext },
  })

export default Wrapper
